import Network from '@/services/network'

export default function handleAuditTrail() {
    const network = new Network;

    const fetchAuditTrail = (query) => {
        return network.api('get', '/reports/audit-trail' + query);
    }

    const fetchAuditTrailDetail = (id, query) => {
        return network.api('get', `/reports/audit-trail/${id}` + query);
    }

    const getAuditTrailExportUrl = (query) => {
        const token = localStorage.getItem('token')
        return `${process.env.VUE_APP_BASE_URL}/export/reports/audit-trail${query}&_token=${token}`
    }

    return {
        fetchAuditTrail,
        fetchAuditTrailDetail,
        getAuditTrailExportUrl
    }
}
